import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-hand-raised-icon',
  imports: [],
  templateUrl: './hand-raised-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './hand-raised-icon.component.scss',
})
export class HandRaisedIconComponent {}
